/**
 * Utilitário centralizado para máscara visual de CNPJ.
 *
 * Responsabilidade:
 * - Definir a máscara adequada para campos de CNPJ no front-end.
 * - Diferenciar a máscara de CNPJ numérico da máscara de CNPJ alfanumérico.
 *
 * Este arquivo deve tratar apenas regra de apresentação.
 * Validação, normalização e formatação do valor pertencem ao arquivo `cnpj.js`.
 *
 * Exemplos de uso:
 *
 * import { obterMascaraCnpj } from '@/util/cnpjMask'
 *
 * const mascara = obterMascaraCnpj('AB123456000195')
 */

import { normalizarCnpj } from './cnpj'

export const MASCARA_CNPJ_NUMERICO = '##.###.###/####-##'
export const MASCARA_CNPJ_ALFANUMERICO = 'NN.NNN.NNN/NNNN-##'

const REGEX_LETRA = /[A-Za-z]/
const contemLetra = (valor) => REGEX_LETRA.test(valor)

/**
 * Retorna a máscara visual adequada para o valor informado.
 *
 * Regra: campo vazio ou com letra retorna a máscara alfanumérica (token N, aceita letra ou dígito).
 * Apenas dígitos retorna a máscara numérica (token #, aceita só dígito).
 *
 * Importante: não usar classificadores de valor completo (ex: ehAlfanumerico, length === 14)
 * para decidir a máscara durante digitação — o valor parcial nunca satisfaz o classificador
 * e a máscara nunca muda para o tipo novo (deadlock de digitação). Ver L-48.
 *
 * @param {string|number|null|undefined} valor
 * @returns {string}
 */
export const obterMascaraCnpj = (valor) => {
  const cnpj = normalizarCnpj(valor)

  if (!cnpj || contemLetra(cnpj)) {
    return MASCARA_CNPJ_ALFANUMERICO
  }

  return MASCARA_CNPJ_NUMERICO
}

export default {
  MASCARA_CNPJ_NUMERICO,
  MASCARA_CNPJ_ALFANUMERICO,
  obterMascaraCnpj
}
